import { render, staticRenderFns } from "./infoAction.vue?vue&type=template&id=6c2a656f&scoped=true&"
import script from "./infoAction.vue?vue&type=script&lang=js&"
export * from "./infoAction.vue?vue&type=script&lang=js&"
import style0 from "./infoAction.vue?vue&type=style&index=0&id=6c2a656f&lang=scss&scoped=true&"
import style1 from "./infoAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a656f",
  null
  
)

component.options.__file = "infoAction.vue"
export default component.exports